import { translate } from "../../util/translate"

export const rechargeHeadersAdmin = [
  {
    text: 'Code',
    value: 'code',
    width: 80,
  },
  {
    text: translate['recharge.label.type'],
    value: 'type',
    width: 190,
  },
  {
    text: translate['recharge.label.real_estate'],
    value: 'real_estate',
  },
  {
    text: translate['recharge.label.comment'],
    value: 'comment'
  },
  {
    text: translate['recharge.label.date_created'],
    value: 'date_created',
  },
  {
    text: translate['recharge.label.due_date'],
    value: 'due_date',
    width: 150,
  },
  {
    text: translate['recharge.label.amount'],
    value: 'value',
    align: 'end',
    width: 150,
  },
  {
    text: translate['recharge.label.status'],
    value: 'status',
  },
  {
    text: translate['recharge.label.attachments'],
    value: 'attachments',
    align: 'end',
    width: 50,
  },
  {
    text: translate['recharge.label.isAdvancedBalance'],
    value: 'advanced_balance',
    align: 'end',
  },
]
